module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage"
  }, [(!_vm.$store.getters.isLoading) ? _c('div', {
    staticClass: "homepage__content"
  }, [_vm._m(0), _c('div', {
    ref: "scroller",
    staticClass: "homepage__slider fullscreen-slider",
    class: {
      'is-intro': _vm.isIntro, 'is-last': _vm.isLast
    },
    attrs: {
      "block": _vm.isAnimating || _vm.$store.getters.isPopupOpened
    }
  }, [_c('transition-wrapper', {
    attrs: {
      "mode": "out-in",
      "appear": true
    },
    on: {
      "transition-start": function($event) {
        _vm.isAnimating = true
      },
      "transition-end": function($event) {
        _vm.isAnimating = false
      }
    }
  }, [(_vm.isIntro) ? _c('intro-slide', {
    staticClass: "fullscreen-slider__slide",
    attrs: {
      "label": _vm.pageContent.title,
      "head": _vm.pageContent.description
    }
  }) : (!_vm.isLast) ? _c('regular-slide', {
    key: _vm.currentSlide,
    staticClass: "fullscreen-slider__slide",
    attrs: {
      "slides": _vm.slides,
      "image": _vm.currentSlideData.media.url,
      "media": _vm.currentSlideData.media.json,
      "media-loop": _vm.currentSlideData.media.loop,
      "title": _vm.currentSlideData.title,
      "text": _vm.currentSlideData.description
    }
  }) : _c('empty-slide', {
    key: _vm.currentSlide,
    staticClass: "fullscreen-slide__slide"
  })], 1), _c('transition-wrapper', {
    attrs: {
      "appear": true
    }
  }, [(_vm.isIntro) ? _c('dots', {
    key: _vm.isIntro,
    staticClass: "fullscreen-slider__navigation is-intro",
    attrs: {
      "items": _vm.navigationItems,
      "current": _vm.currentSlide
    }
  }) : _c('dots', {
    key: _vm.isIntro,
    staticClass: "fullscreen-slider__navigation",
    attrs: {
      "items": _vm.navigationItems,
      "current": _vm.currentSlide
    }
  })], 1)], 1), _c('the-footer', {
    staticClass: "homepage__footer",
    attrs: {
      "block": !_vm.isLast
    },
    on: {
      "scroll-up": _vm.prevSlide
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magicTriggerBox"
  }, [_c('div', {
    staticClass: "magicTrigger1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87097352","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/index.vue
// module id = 497
// module chunks = 0